import { Table } from 'antd';
import {
	FunctionaryInfo,
	Pagination,
	PagingConfig,
} from '../../../../shared/VolunteerApplicationServiceTypes';
import { tablePaginationConfiguration } from '../../../../shared/Utils';
import { ProposerReassignTableListColumns } from './ProposerReassignTableColumns';

interface ProposerReassignTableProps {
	proposers: FunctionaryInfo[] | undefined;
	paging: PagingConfig;
	pagination: Pagination;
	onPageChange: (page: number, pageSize: number) => void;
	onSubmitClick: (functionaryId?: number) => void;
}

export const ProposerReassignTable = (props: ProposerReassignTableProps) => {
	const { proposers, onSubmitClick, paging, onPageChange, pagination } = props;

	const tablePaginationConfig = tablePaginationConfiguration(
		paging,
		pagination,
		onPageChange
	);

	const columns = ProposerReassignTableListColumns({ onSubmitClick });

	return (
		<>
			<Table
				columns={columns}
				dataSource={proposers}
				pagination={tablePaginationConfig}
				scroll={{ x: 'max-content' }}
				rowClassName={() => 'border-b border-gray-300 bg-white'}
				className="w-full overflow-x-auto !border-separate !border-spacing-y-0"
			/>
		</>
	);
};
